var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataGrid',{attrs:{"config":_vm.dataGridConfig,"data":_vm.facturas}},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn warning-btn",on:{"click":_vm.obtener_facturas}},[_vm._v("Recargar")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }